import React from 'react'
import { connect } from 'react-redux'
import { getPresentations, uploadPresentation, deletePresentation, getPresentation, sendRenamePresentation, downloadPresentation, getConnectionInfos, clearPresentationView } from '../../actions/presentationActions'
import { bindActionCreators } from 'redux'
import { applyFilter, showMessage, showPopup, closePopup } from '../../actions/uiActions'
import { updateCustomerMessage, getCustomers, getTeams } from '../../actions/userActions'
import Presentations from '../../components/main/Presentations'

class PresentationsContainer extends React.Component {
    componentDidMount() {
        if (this.props.presentationList.length === 0 && !this.props.presentationCheck) {
            this.props.getPresentations()
            this.props.getTeams()
        } 
        this.props.clearPresentationView()
        if (this.props.role === "IEAdmin") {
            this.props.getCustomers()
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.completedLoad !== this.props.completedLoad && this.props.completedLoad !== -1) {
            this.props.closePopup()
        }
    }

    render() {
        return (
            <Presentations role={this.props.role}
                customerID={this.props.customerID}
                custFolderList={this.props.custFolderList}
                presentationList={this.props.presentationList}
                presentationFilter={this.props.presentationFilter}
                applyFilter={this.props.applyFilter}
                uploadPresentation={this.props.uploadPresentation}
                deletePresentation={this.props.deletePresentation}
                getPresentation={this.props.getPresentation}
                sendRenamePresentation={this.props.sendRenamePresentation}
                downloadPresentation={this.props.downloadPresentation}
                connInfos={this.props.connInfos}
                sendEditConnectionString={this.props.sendEditConnectionString}
                showPopup={this.props.showPopup}
                presentationsProgress={this.props.presentationsProgress}
                updateCustomerMessage={this.props.updateCustomerMessage}
                {...this.props}
            />
        )
    }

}


function mapStateToProps(state) {
    return {
        presentationList: state.presentations.present.presentationList,
        custFolderList: state.users.custFolderList,
        role: state.users.role,
        customerID: state.users.customerID,
        presentationCheck: state.presentations.present.presentationCheck,
        presentationFilter: state.presentations.present.presentationFilter, 
        connInfos: state.presentations.present.connInfos,
        presentationsProgress: state.presentations.present.presentationsProgress,
        message: state.users.message,
        email: state.users.email,
        teamList: state.users.teamList,
        tagsList: state.presentations.present.tagsList,
        presentationTagsFilter: state.presentations.present.presentationTagsFilter,
        completedLoad: state.presentations.present.completedLoad,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(
            {
                getPresentations,
                applyFilter,
                uploadPresentation,
                deletePresentation,
                getPresentation,
                sendRenamePresentation,
                downloadPresentation,
                getConnectionInfos,
                showMessage,
                showPopup,
                clearPresentationView,
                updateCustomerMessage,
                getCustomers,
                getTeams,
                closePopup,
            }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PresentationsContainer)